import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./HeroSection.css";

const slides = [
  {
    image: `${process.env.PUBLIC_URL}/images/land-1.webp`,
    title: " أعمال المسبح التجارية",
    subtitle: "ابتكار وتصنيع منتجات أمان المسابح والنوافير منذ عام 2018",
    animType: "pattern-1", // 👈 الأزرار يمين وشمال
  },
  {
    image: `${process.env.PUBLIC_URL}/images/land-2.webp`,
    title: "حلول تجمع بين الأمان والتصميم الأنيق",
    subtitle: "حاصلون على براءة اختراع خليجية ونتميز كمصنعين ومبتكرين",
    animType: "pattern-2", // 👈 الأزرار بتطلع من تحت بنعومة
  },
  {
    image: `${process.env.PUBLIC_URL}/images/land-3.webp`,
    title: "جودة معتمدة وشلالات وإكسسوارات متكاملة",
    subtitle: "نخدم عملاءنا في جميع مدن المملكة العربية السعودية ودول الخليج العربي",
    animType: "pattern-3", // 👈 الأزرار بتكبر تدريجيًا (Zoom)
  },
];

const HeroSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // 1. التايمر التلقائي
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === slides.length - 1 ? 0 : prevIndex + 1
      );
    }, 5500);

    return () => clearInterval(interval);
  }, [currentIndex]);

  // 2. Preload للصور
  useEffect(() => {
    slides.forEach((slide, index) => {
      if (index !== currentIndex) {
        const img = new Image();
        img.src = slide.image;
      }
    });
  }, [currentIndex]);

  const currentSlide = slides[currentIndex];

  return (
    <section id="hero" className="hero-section p-0">
      {/* الخلفيات مع تأثير الزوم المتغير */}
      {slides.map((slide, index) => (
        <img
          key={index}
          src={slide.image}
          alt={`land-${index}`}
          className={`hero-background ${index === currentIndex ? "active" : ""} ${slide.animType}`}
          loading="lazy"
        />
      ))}

      <div className="hero-overlay d-flex align-items-center justify-content-center">
        <Container style={{ paddingTop: "66px" }}>
          <Row className="align-items-center">
            <Col lg={12} className="text-center">
              {/* مفتاح الـ key هنا يضمن إعادة تشغيل الأنيميشن تلقائياً مع كل سلايد */}
              <div key={currentIndex} className={`hero-content ${currentSlide.animType}`}>
                <h1 className="hero-title mb-4">
                  {currentSlide.title}
                </h1>
                
                <p className="hero-subtitle mb-4">
                  {currentSlide.subtitle}
                </p>

                {/* حاوية الأزرار المتنوعة الحركة */}
                <div className="hero-buttons">
                  <Button
                    size="lg"
                    className="btn1 btn-first"
                    onClick={() =>
                      document
                        .getElementById("contact")
                        ?.scrollIntoView({ behavior: "smooth" })
                    }
                  >
                    تواصل معنا
                  </Button>
                  <Button
                    variant="outline-light"
                    size="lg"
                    className="btn-second"
                    onClick={() =>
                      document
                        .getElementById("products")
                        ?.scrollIntoView({ behavior: "smooth" })
                    }
                  >
                    منتجاتنا
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        {/* المؤشرات السفلية الناعمة */}
        <div className="carousel-indicators-custom">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`indicator-dot ${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;